import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Screen } from "../components/Screen";
import { Button } from "../components/Button";
import { SourceSheet } from "../components/SourceSheet";
import { LoadingScreen } from "../components/LoadingScreen";
import { useQuiz } from "../features/quiz/QuizContext";
import styles from "./MistakeReviewScreen.module.css";

export function MistakeReviewScreen() {
  const navigate = useNavigate();
  const { mistakes, loadMistakes, scoreResult } = useQuiz();
  const [openSourceFor, setOpenSourceFor] = useState<string | null>(null);

  useEffect(() => {
    if (!scoreResult) {
      navigate("/", { replace: true });
      return;
    }
    void loadMistakes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!scoreResult) return null;
  if (!mistakes) return <LoadingScreen />;

  return (
    <Screen>
      <h1 className={styles.title}>Разбор ошибок</h1>

      {mistakes.map((m) => (
        <div key={m.questionId} className={styles.item}>
          <span className={styles.topic}>{m.topic}</span>
          <p className={styles.question}>{m.questionText}</p>

          {m.options.map((o) => {
            const isCorrect = o.id === m.correctOptionId;
            const isSelected = o.id === m.selectedOptionId;
            const cls = [styles.optionRow, isCorrect ? styles.correct : "", isSelected && !isCorrect ? styles.selected : ""]
              .filter(Boolean)
              .join(" ");
            return (
              <div key={o.id} className={cls}>
                {o.text}
              </div>
            );
          })}

          <p className={styles.explanation}>{m.explanation}</p>
          <Button variant="secondary" onClick={() => setOpenSourceFor(m.sourceFragmentId)}>
            Источник
          </Button>
        </div>
      ))}

      <div className={styles.back}>
        <Button onClick={() => navigate("/result")}>К результату</Button>
      </div>

      {openSourceFor && <SourceSheet fragmentId={openSourceFor} onClose={() => setOpenSourceFor(null)} />}
    </Screen>
  );
}
